import { createFileRoute } from '@tanstack/react-router'
import { OnboardingPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/onboarding')({
  head: () => noIndexRouteHead('onboarding', 'de'),
  component: OnboardingPage,
})
